import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=08fbbc43"
import script from "./Study.vue?vue&type=script&lang=js"
export * from "./Study.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports